mutation CreateTagType($input: CreateTagTypeInput!) {
  createTagType(input: $input) {
    id
    title
    featured
    seoDescription
    defaultPreviewType
    customFields {
      type
      name
      label
      required
      multiple
      placeholder
      helperText
      options {
        value
        label
      }
    }
  }
}
